module.exports = __webpack_public_path__ + "static/media/model.c2576ed5.glb";